export default __webpack_public_path__ + "static/media/Category-Language-transparent.d36c653f.png";